var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from 'react';
import classNames from 'classnames';
import { isObject } from '../../utils';
var Col = /** @class */ (function (_super) {
    __extends(Col, _super);
    function Col() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getColumnSizeClass = function (isXs, colWidth, colSize) {
            if (colSize === '') {
                return isXs ? 'ac-col' : "ac-col-" + colWidth;
            }
            else if (colSize === 'auto') {
                return isXs ? 'ac-col-auto' : "ac-col-" + colWidth + "-auto";
            }
            return isXs ? "ac-col-" + colSize : "ac-col-" + colWidth + "-" + colSize;
        };
        _this.getColClasses = function () {
            var attributes = _this.props.attributes;
            var colClasses = [];
            var colWidths = ['xs', 'sm', 'md', 'lg', 'xl'];
            colWidths.forEach(function (colWidth, i) {
                var _a;
                var columnProp = _this.props[colWidth];
                if (attributes) {
                    delete attributes[colWidth];
                }
                if (!columnProp && columnProp !== '') {
                    return;
                }
                var isXs = i === 0;
                if (isObject(columnProp)) {
                    var colSizeInterfix = isXs ? '-' : "-" + colWidth + "-";
                    var colClass = _this.getColumnSizeClass(isXs, colWidth, columnProp.size);
                    colClasses.push(classNames((_a = {},
                        _a[colClass] = columnProp.size || columnProp.size === '',
                        _a["order" + colSizeInterfix + columnProp.order] = columnProp.order || columnProp.order === 0,
                        _a["offset" + colSizeInterfix + columnProp.offset] = columnProp.offset || columnProp.offset === 0,
                        _a)));
                }
                else {
                    var colClass = _this.getColumnSizeClass(isXs, colWidth, columnProp);
                    colClasses.push(colClass);
                }
            });
            if (!colClasses.length) {
                colClasses.push('ac-col');
            }
            return colClasses;
        };
        return _this;
    }
    Col.prototype.render = function () {
        var _a = this.props, className = _a.className, attributes = _a.attributes, children = _a.children;
        var resultClassName = classNames(className, this.getColClasses());
        return (React.createElement("div", __assign({}, attributes, { className: resultClassName }), children));
    };
    return Col;
}(Component));
export default Col;
//# sourceMappingURL=Col.js.map